webpackJsonp([10991734084388],{

/***/ 330:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.AboutQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _aos = __webpack_require__(3);
	
	var _aos2 = _interopRequireDefault(_aos);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(4);
	
	__webpack_require__(330);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AboutPage = function (_React$Component) {
	  _inherits(AboutPage, _React$Component);
	
	  function AboutPage(props) {
	    _classCallCheck(this, AboutPage);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    // this.teamData = this.props.data.allAboutYaml.edges[1].node.team;
	    // console.log(this.teamData);
	    //this.partnersData = this.props.data.allAboutYaml.edges[1].node.partners;
	  }
	
	  AboutPage.prototype.componentDidMount = function componentDidMount() {
	    var isBrowser = typeof window !== 'undefined';
	    var AOS = isBrowser ? __webpack_require__(3) : undefined;
	    this.aos = AOS;
	    this.aos.init();
	  };
	
	  AboutPage.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.aos.refresh();
	  };
	
	  AboutPage.prototype.render = function render() {
	
	    var teamData = this.props.data.allAboutYaml.edges[1].node.team;
	    console.log(teamData);
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'About us | Invest as you spend'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'We\'re giving Australians access to high quality financial education, technology and services.' })
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'first', 'data-aos': 'fade-up', 'data-aos-once': true },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'inner-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                'Live a happier financial life'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'We\'re giving Australians access to high quality',
	                _react2.default.createElement('br', null),
	                ' financial education, technology and services.'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'feature-icons' },
	              _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/icons/icon-rising.svg'), className: 'feature-icon rising', alt: 'Feature icon' }),
	              _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/icons/icon-search.svg'), className: 'feature-icon search', alt: 'Feature icon' }),
	              _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/icons/icon-floppy.svg'), className: 'feature-icon floppy', alt: 'Feature icon' }),
	              _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/icons/icon-shield.svg'), className: 'feature-icon shield', alt: 'Feature icon' })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'team', 'data-aos': 'fade-up', 'data-aos-once': true },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'team-title' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'We believe in inspiring and motivating Australians to invest. Invsting create opportunities to thrive. With FirstStep we can make it possible.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Our talented team is devoted to designing and delivering powerful technology that reimagines investing and help shape a growing community realise new possibilities.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'To do this FirstStep places high value on trust, integrity, deep expertise, security and partnerships. Our promise is to harness great insight, hindsight and foresight and partner it with great technology enabling thousands of Australians to invest.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'members' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              teamData && teamData.map(function (item, index) {
	                return _react2.default.createElement(
	                  'div',
	                  { className: 'col-12 col-sm-4 col-lg-3', key: index },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'member' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'member-photo' },
	                      _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)(item.member.image), className: 'img-photo', alt: 'Member photo' }),
	                      _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/patterns/triangle.png'), className: 'bg-photo', alt: 'Pattern background' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'member-info' },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'title' },
	                        item.member.name
	                      ),
	                      _react2.default.createElement(
	                        'h5',
	                        { className: 'caption' },
	                        item.member.title
	                      )
	                    )
	                  )
	                );
	              })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return AboutPage;
	}(_react2.default.Component);
	
	exports.default = AboutPage;
	var AboutQuery = exports.AboutQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-index-js-df91b26268a9b31dcce9.js